import type { PerformanceDatapoint } from 'owa-analytics';
import type { CustomData } from 'owa-analytics-types';
import { isSharedCalendar } from './isSharedCalendar';
import { getSharedCalendarType } from './getSharedCalendarType';
import { getEffectiveRightsString } from './getEffectiveRightsString';
import type { CalendarEntry } from 'owa-graph-schema';

/**
 * Get calendar sharing telemetry data for usage logging
 */
export function getCalendarSharingTelemetryData(
    calendarEntry: CalendarEntry | undefined
): CustomData {
    return {
        isSharedCalendar: isSharedCalendar(calendarEntry),
        sharingType: getSharedCalendarType(calendarEntry),
        effectiveRights: getEffectiveRightsString(calendarEntry),
    };
}

/**
 * Add calendar sharing properties to a performance datapoint
 */
export const logCalendarSharingProperties = (
    datapoint: PerformanceDatapoint,
    calendarEntry: CalendarEntry | undefined
): void => {
    if (calendarEntry) {
        // Do not log calendarId if it is an email address
        const shouldLogCalendarId =
            calendarEntry.calendarId.id && !calendarEntry.calendarId.id.includes('@');

        if (shouldLogCalendarId) {
            datapoint.addCustomData({ calendarId: calendarEntry.calendarId.id });
        }

        datapoint.addCustomData(getCalendarSharingTelemetryData(calendarEntry));
    }
};
